<template>
  <div class="step-container scrollPosition">
    <div class="step-header">
      <h2 class="step-title">Basis-Infos</h2>
      <p class="step-text">Geben Sie die Eckpunkte der Immobilie an.</p>
    </div>
    <div class="step-body">
      <div class="row gx-5 justify-content-center">
        <div class="col-md-6">
          <InputRange
            id="ws1_s1"
            min="200"
            max="4000"
            v-model="fields.grundFlaeche.value"
            :defaultValue="fields.grundFlaeche.default"
            label="Grundstücksfläche gesamt"
            unit="m²"
            @update:modelValue="validate('grundFlaeche')"
            :state="fields.grundFlaeche.state"
          />
        </div>
        <div class="col-md-6">
          <InputRange
            id="ws1_s2"
            min="200"
            max="4000"
            v-model="fields.davonBauland.value"
            :defaultValue="fields.davonBauland.default"
            label="Grundstücksfläche Bauland"
            unit="m²"
            @update:modelValue="validate('davonBauland')"
            :state="fields.davonBauland.state"
          />
        </div>
      </div>
    </div>
    <div class="step-footer">
      <div class="row align-items-center">
        <div class="col-md-4 col-6">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
        <div class="col-md-4 col-6 next-container">
          <button
            class="next-btn"
            @click="goNext()"
          >
            Weiter
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import InputRange from "@/components/shared/InputRange.vue";
import {
  getFromStorage,
  saveToStorage,
  checkValidFields,
  checkInvalidFields,
  containsInvalidFields,
  validateField,
  setDefaults,
} from "@/utils.js";
export default {
  name: "wohnung-step-2",
  components: {
    InputRange,
  },

  data() {
    return {
      fields: {
        grundFlaeche: {
          default: "500",
          validators: ["required", "min:200", "max:4000"],
        },
        davonBauland: {
          default: "500",
          validators: ["required", "min:200", "max:4000"],
        },
      },
    };
  },
  methods: {
    goBack() {
      setDefaults(this.fields);
      saveToStorage(this.fields);
      this.$router.push("/baugrundstueck-step-1");
    },
    goNext() {
      setDefaults(this.fields);
      checkInvalidFields(this.fields);
      if (!containsInvalidFields(this.fields)) {
        saveToStorage(this.fields);
        this.$router.push("/baugrundstueck-step-3");
      }
    },
    validate(name) {
      const field = this.fields[name];
      field.state = validateField(field.value, field.validators);
    },
  },
  mounted() {
    this.$emit("setStep", "baugrundstueck", 3);
    getFromStorage(this.fields);
    checkValidFields(this.fields);
  },
};
</script>
<style scoped>
.step-body {
  margin-bottom: 55px;
}
.step-body .row {
  row-gap: 55px;
}
@media only screen and (max-width: 768px) {
  .step-body {
    margin-bottom: 55px;
  }
}
</style>
